import React from 'react';
import { downloadProgramInventorySpreadsheet, downloadProgramProcessOverlapExcel, downloadProgramProcessOverlapPDF } from '../../services/downloadService.js';
import { AGGridColumnNumberComparator } from '../System/AgGrid/RegisterAgGridModules.js';
//import { utils, read } from 'xlsx';
import TableCellButton from '../reusable/AgGridCells/TableCellButton/TableCellButton.js';
import { constructMissingColumnsMessage, normalizeColumnName, normalizeRowsToExpectedColumns, trimValue } from '../reusable/reusableFunctions.js';
import ErrorIconColumn from '../reusable/AgGridCells/ErrorIconCell/ErrorIconCell.js';
import { messageManager } from '../System/messageManager/messageManager.js';
import { TABLE_COLUMN_WIDTH } from '../../static/constants.js';
import { EDIT_TYPE_LABELS } from '../../static/constants.js';
import { REDUCER_ACTION_TYPES } from '../../store/Reducer.js';
import { DESCRIPTION, PROGRAM, PROGRAM_DEPARTMENT, PROGRAM_DIVISION, PROGRAM_NUM, USER_GROUP } from '../../static/keyWords.js';

export const ACCEPTED_FILES = ['.xlsx', '.xls', '.csv'];
export const INITIAL_FILE_STATE = { name: '', description: '', file: '' };
const serviceTypes = ['community', 'governance', 'fixed'];
export const ADD_PROGRAM_DIALOG_INITIAL_STATE = { open: false, dialog: '' };
export const SUCCESS_ADD_TOAST_INITIAL_STATE = { open: false, numberOfPrograms: 0 };
export const getRenderCondition = (loadFile, uploadedFile) => {
  return loadFile && uploadedFile.name;
};
export const emptyFieldCondition = (e, nameConventions) => {
  if (!e?.data?.name || !e?.data?.name?.trim()?.length) return `${nameConventions[PROGRAM].alias} name is required.`;
  if (!e?.data?.description || !e?.data?.description?.trim()?.length) return `${nameConventions[PROGRAM].alias} description is required.`;
  if (!e?.data?.costCenter || !e?.data?.costCenter?.name?.trim()?.length) return `${nameConventions[USER_GROUP].alias} is required`;
  if (!e?.data?.serviceType || !e?.data?.serviceType?.name?.trim()?.length) return 'Service type is required';
  return false;
};

export const emptyAddProgramFieldCondition = (
  progName,
  description,
  selectedServiceType,
  selectedCostCenter
) => {
  return (
    !progName.trimStart() || !description.trimStart() || !selectedServiceType || !selectedCostCenter
  );
};

export const getTableColumns = (
  activeCostCenters,
  departmentsAndDivisions,
  serviceTypes,
  costCenters,
  handleClickDeleteSingleProgram,
  user,
  nameConventions,
  showColumns
) => {
  let showColumnsProgramInventory = showColumns.programInventoryColumns;

  return [
    {
      colId: '1',
      context: 'Service Type',
      headerName: 'Service type',
      headerTooltip: 'Service type',
      tooltipField: 'serviceType.name',
      field: 'serviceType.name',
      hide: !showColumnsProgramInventory?.find((column) => column.name === 'Service Type')?.show,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: serviceTypes.map((serviceType) => serviceType.name),
      },
      width: TABLE_COLUMN_WIDTH.MD
    },
    {
      colId: '2',
      headerName:
        nameConventions[PROGRAM_DEPARTMENT].alias || PROGRAM_DEPARTMENT,
      headerTooltip:
        nameConventions[PROGRAM_DEPARTMENT].alias || PROGRAM_DEPARTMENT,
      tooltipField: 'department',
      context: PROGRAM_DEPARTMENT,
      hide: !showColumnsProgramInventory?.find((column) => column.name === PROGRAM_DEPARTMENT)?.show,
      field: 'department',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values:
          departmentsAndDivisions &&
          departmentsAndDivisions.departments &&
          departmentsAndDivisions.departments.length > 0 &&
          [...new Set(departmentsAndDivisions?.departments)],
        allowTyping: true,
        highlightMatch: true,
      },
      cellStyle: { display: 'block' },
      width: TABLE_COLUMN_WIDTH.XL
    },
    {
      colId: '3',
      context: PROGRAM_DIVISION,
      headerName: nameConventions[PROGRAM_DIVISION].alias || PROGRAM_DIVISION,
      headerTooltip:
        nameConventions[PROGRAM_DIVISION].alias || PROGRAM_DIVISION,
      tooltipField: 'division',
      hide: !showColumnsProgramInventory?.find((column) => column.name === PROGRAM_DIVISION)?.show,
      field: 'division',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values:
          departmentsAndDivisions &&
          departmentsAndDivisions.divisions &&
          departmentsAndDivisions.divisions.length > 0 &&
          [...new Set(departmentsAndDivisions.divisions)],
        allowTyping: true,
        highlightMatch: true,
      },
      editable: true,
      cellStyle: { display: 'block' },
      width: TABLE_COLUMN_WIDTH.XL
    },
    {
      colId: '4',
      context: 'Program number',
      headerName: 'Program number',
      headerTooltip: 'Program number',
      tooltipField: 'number',
      field: 'number',
      hide: !showColumnsProgramInventory?.find((column) => column.name === PROGRAM_NUM)?.show,
      cellClass: 'grid-cell-flex-end',
      editable: true,
      comparator: AGGridColumnNumberComparator,
      width: TABLE_COLUMN_WIDTH.MD
    },

    {
      colId: '5',
      context: PROGRAM,
      headerName: nameConventions[PROGRAM].alias || PROGRAM,
      headerTooltip: nameConventions[PROGRAM].alias || PROGRAM,
      tooltipField: 'name',
      field: 'name',
      editable: true,
      valueSetter: (params) => {
        params.data.name = typeof params.newValue === 'string'
          ? params.newValue.trim().replace(/\s+/g, ' ')
          : params.newValue;
        return true;
      },
      sort: 'asc',
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      suppressColumnsToolPanel: true,
      // cellClass: (params) => {
      //   return params.data.name && params.data.name.trim().length !== 0
      //     ? 'normalCell'
      //     : 'emptyRequiredCell';
      // },
      cellStyle: { display: 'block' },
      width: TABLE_COLUMN_WIDTH.DEFAULT
    },
    {
      colId: '6',
      context: 'Description',
      headerName: 'Description',
      headerTooltip: 'Description',
      tooltipField: 'description',
      field: 'description',
      hide: !showColumnsProgramInventory?.find((column) => column.name === 'Description')?.show,
      cellEditorPopup: true,
      // cellClass: (params) => {
      //   return params.data.description &&
      //     params.data.description.trim().length !== 0
      //     ? 'normalCell'
      //     : 'emptyRequiredCell';
      // },
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: { maxLength: 100000 },
      cellStyle: { display: 'block' },
      width: TABLE_COLUMN_WIDTH.DEFAULT
    },
    {
      colId: '7',
      context: USER_GROUP,
      headerName: nameConventions[USER_GROUP].alias || USER_GROUP,
      headerTooltip: nameConventions[USER_GROUP].alias || USER_GROUP,
      tooltipField: 'costCenter.name',
      field: 'costCenter.name',
      hide: !showColumnsProgramInventory?.find((column) => column.name === USER_GROUP)?.show,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: getTableCostCenterOptions(activeCostCenters, costCenters),
        allowTyping: true,
        highlightMatch: true,
      },
      editable: true,
      cellStyle: { display: 'block' },
      width: TABLE_COLUMN_WIDTH.DEFAULT
    },
    {
      colId: '8',
      context: 'ProgID',
      headerName: 'ProgID',
      headerTooltip: 'Program ID',
      tooltipField: 'id',
      field: 'id',
      hide: !showColumnsProgramInventory?.find((column) => column.name === 'ProgID')?.show,
      editable: false,
      filter: true,
      lockPosition: 'left',
      suppressMovable: true,
      cellClass: 'grid-cell-flex-end',
      comparator: AGGridColumnNumberComparator,
      pinned: 'left',
      resizable: false,
      width: TABLE_COLUMN_WIDTH.XS,
    },
    ErrorIconColumn(),
    {
      colId: '9',
      context: 'Actions',
      headerName: 'Actions',
      headerTooltip: 'Actions',
      tooltipValueGetter: () => `Delete ${nameConventions[PROGRAM].alias}`,
      field: '',
      filter: false,
      suppressFloatingFilterButton: true,
      suppressColumnsToolPanel: true,
      sortable: false,
      editable: false,
      resizable: false,
      cellRenderer: (params) => {
        return (
          <TableCellButton
            label={`Delete ${nameConventions[PROGRAM].alias}`}
            data={params.data}
            handleClick={handleClickDeleteSingleProgram}
            icon={'delete'}
            disabled={user?.isViewOnly}
          />
        );
      },
      cellClass: 'grid-cell-centered',
      width: TABLE_COLUMN_WIDTH.XS,
      pinned: 'right',
      lockPosition: 'right',
    },
  ];
};

const getTableCostCenterOptions = (activeCostCenters, allCostCenters) => {
  if ((activeCostCenters || []).length > 0) {
    return [...activeCostCenters];
  }

  return [...allCostCenters];
};

const getOrgLevelEditorValues = (items) => {
  if (!items?.length) {
    return [];
  }

  return [...new Set(items)];
};

export const getSubmitDataRows = (editedRows, serviceTypes, costCenters) => {
  let dataRows = [];
  for (let rowData of editedRows) {
    rowData.edit = 'Edit';
    const serviceType = getServiceType(rowData.serviceType, serviceTypes);
    rowData.serviceType = serviceType;
    rowData.serviceTypeId = serviceType.id;
    const costCenter = getCostCenter(rowData.costCenter, costCenters);
    rowData.costCenter = costCenter;
    rowData.organizationLevels = (rowData.department || '') + '--' + (rowData.division || '');
    dataRows.push(rowData);
  }
  return dataRows;
};

const getServiceType = (serviceTypeName, serviceTypes) => {
  if (serviceTypeName.name)
    return serviceTypes.find(
      (serviceType) => serviceType.name === serviceTypeName.name
    );
  else
    return serviceTypes.find(
      (serviceType) => serviceType.name === serviceTypeName
    );
};

const getCostCenter = (CostCenterName, costCenters) => {
  if (CostCenterName && CostCenterName.name)
    return costCenters.find((CostCenter) => CostCenter === CostCenterName.name);
  else return costCenters.find((CostCenter) => CostCenter === CostCenterName);
};

export const fireSelectedDialog = (
  e,
  setAddProgramDialog,
  deselectGridRows
) => {
  switch (e.detail.value) {
    case 'newProgram':
      setAddProgramDialog({ open: true, dialog: 'newProgram' });
      deselectGridRows();
      break;
    case 'programFromSearch':
      setAddProgramDialog({ open: true, dialog: 'searchPopup' });
      deselectGridRows();
      break;
    case 'programFromStarterKit':
      setAddProgramDialog({ open: true, dialog: 'starterKit' });
      deselectGridRows();
      break;
    default:
      break;
  }
};

export const generatePrograms = (programs, user) => {
  return filterByCostCenters(
    programs.data.map((program) => {
      return generateDepartmentAndDivisionForProgram(program);
    }), user
  );
};

export const generateDepartments = (departments) => {
  return departments.data.organizationLevels.map((dept) => dept.name);
};

export const generateDivisions = (divisions, orgLvl) => {
  if (orgLvl.length <= 1) {
    return [];
  }
  return divisions.data.organizationLevels.map((div) => div.name);
};

const generateDepartmentAndDivisionForProgram = (program) => {
  return {
    ...program,
    department: program.organizationLevels
      ? program.organizationLevels.split('--')[0]
      : null,
    division: program.organizationLevels
      ? program.organizationLevels.split('--')[1]
      : null,
  };
};

const filterByCostCenters = (data, user) => {
  const activeCostCenters = user.activeCostCenters;
  const allCostCenters = user.costCenters;

  if (
    activeCostCenters &&
    activeCostCenters.length > 0 &&
    activeCostCenters.length !== allCostCenters.length
  ) {
    let filteredRows = data.filter((program) =>
      activeCostCenters.find((acc) => acc === program.costCenter.name.trim())
    );
    return filteredRows;
  } else {
    return data;
  }
};

export const generateResponse = (data) => {
  const programResponse = data[0];
  const serviceTypeResponse = data[1];
  const filteredData = data[2];
  const itemsResponse = data[3];

  return {
    programResponse,
    serviceTypeResponse,
    filteredData,
    itemsResponse
  };
};

export const filterServiceTypes = (serviceTypes) => {
  return serviceTypes.filter(
    (serviceType) =>
      serviceType.name === 'Community' ||
      serviceType.name === 'Governance' ||
      serviceType.name === 'Fixed'
  );
};

export const problematicProgramsCondition = (response) => {
  return response.data.duplicatePrograms.length > 0;
};

export const combineProgramsObject = (
  selectedRows,
  costCentersOfProgramsForCombining,
  handleMainProgramSelection,
  handleMainCostCenterSelection,
  nameConventions,
  PROGRAM
) => [
  {
    data: selectedRows,
    onChange: (e) => handleMainProgramSelection(e),
    label: `Select ${nameConventions[PROGRAM]?.alias}`,
    required: true,
    filter: (filterText) =>
      selectedRows
        .map((item) => {
          return { label: item.name, value: item };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
  },
  {
    data: costCentersOfProgramsForCombining,
    onChange: (e) => handleMainCostCenterSelection(e),
    label: `Select ${nameConventions[USER_GROUP]?.alias}`,
    required: true,
    filter: (filterText) =>
      costCentersOfProgramsForCombining
        .map((item) => {
          return { label: item, value: item };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
  },
];

export const addNewProgramObject = (
  serviceTypeNames,
  costCenters,
  filteredDepartmentsFromAccUpload,
  filteredDivisionsFromAccUpload,
  setSelectedServiceType,
  setSelectedCostCenter,
  setDepartmentName,
  setDivisionName,
  programNumber,
  setProgramNumber,
  progName,
  setProgName,
  description,
  setDescription,
  nameConventions,
  setSubgroup,
  setGroup,
  setComments,
  comments,
  group,
  subgroup,
) => [
  {
    type: 'autocomplete',
    required: true,
    data: serviceTypeNames,
    onChange: (e) => setSelectedServiceType(e.detail),
    label: 'Service Type',
    filter: (filterText) =>
      serviceTypeNames
        .map((item) => {
          return { label: item, value: item };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
  },
  {
    type: 'autocomplete',
    required: true,
    data: costCenters,
    onChange: (e) => setSelectedCostCenter(e.detail),
    label: `${nameConventions[USER_GROUP].alias}`,
    filter: (filterText) =>
      costCenters
        .map((item) => {
          return {
            label: item.length > 44 ? item.substring(0, 36) + '...' : item,
            value: item,
          };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
  },
  {
    type: 'autocomplete',
    required: false,
    data: filteredDepartmentsFromAccUpload,
    onChange: (e) => setDepartmentName(e.detail || ''),
    label: `${nameConventions[PROGRAM_DEPARTMENT]?.alias}`,
    disabled: !filteredDepartmentsFromAccUpload.length,
    filter: (filterText) =>
      filteredDepartmentsFromAccUpload
        .map((item) => {
          return { label: item, value: item };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
    class: 'gridPosition2',
  },
  {
    type: 'autocomplete',
    required: false,
    data: filteredDivisionsFromAccUpload,
    disabled: !filteredDivisionsFromAccUpload.length,
    onChange: (e) => setDivisionName(e.detail || ''),
    label: `${nameConventions[PROGRAM_DIVISION]?.alias}`,
    filter: (filterText) =>
      filteredDivisionsFromAccUpload
        .map((item) => {
          return { label: item, value: item };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
  },
  {
    type: 'textfield',
    required: false,
    value: programNumber,
    onChange: (e) => setProgramNumber(e.target.value),
    label: `${nameConventions[PROGRAM]?.alias} Number`,
    class: 'gridPosition3',
  },
  {
    type: 'textfield',
    required: false,
    value: comments,
    onChange: (e) => setComments(e.target.value),
    label: 'Comments',
  },
  {
    type: 'textfield',
    required: false,
    value: group,
    onChange: (e) => setGroup(e.target.value),
    label: 'ProgGroup',
  },
  {
    type: 'textfield',
    required: false,
    value: subgroup,
    onChange: (e) => setSubgroup(e.target.value),
    label: 'ProgSubGroup',
  },
  {
    type: 'textfield',
    required: true,
    value: progName,
    onChange: (e) => setProgName(e.target.value),
    label: `${nameConventions[PROGRAM]?.alias} Name`,
    class: 'gridPositionFullRow4',
  },
  {
    type: 'textarea',
    required: true,
    value: description,
    onChange: (e) => setDescription(e.target.value),
    label: 'Description',
    class: 'gridPositionFullRow5',
  },
];

export const addNewProgramDepartmentAndDivisionObject = (
  filteredDepartmentsFromAccUpload,
  filteredDivisionsFromAccUpload,
  setDepartmentName,
  setDivisionName,
  nameConventions
) => [
  {
    data: filteredDepartmentsFromAccUpload,
    required: false,
    onChange: (e) => setDepartmentName(e.detail),
    label: `${nameConventions[PROGRAM_DEPARTMENT]?.alias}`,
    disabled: !filteredDepartmentsFromAccUpload.length,
    filter: (filterText) =>
      filteredDepartmentsFromAccUpload
        .map((item) => {
          return { label: item, value: item };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
  },
  {
    data: filteredDivisionsFromAccUpload,
    required: false,
    onChange: (e) => setDivisionName(e.detail),
    label: `${nameConventions[PROGRAM_DIVISION]?.alias}`,
    disabled: !filteredDivisionsFromAccUpload.length,
    filter: (filterText) =>
      filteredDivisionsFromAccUpload
        .map((item) => {
          return { label: item, value: item };
        })
        .filter((item) =>
          item.label.toLowerCase().includes(filterText.toLowerCase())
        ),
  },
];

export const getAddNewProgramTableColumns = (
  costCenters,
  serviceTypes,
  activeCostCenters,
  nameConventions
) => {
  return [
    {
      colId: 'addFromStarterKit1',
      headerName: 'Service type',
      headerTooltip: 'Service type',
      tooltipField: 'serviceTypeName',
      field: 'serviceTypeName',
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: serviceTypes.map((serviceType) => serviceType.name),
      },
      editable: true,
      cellStyle: { display: 'block' },
      context: 'Service type',
      width: TABLE_COLUMN_WIDTH.MD,
    },
    {
      colId: 'addFromStarterKit2',
      headerName: nameConventions[PROGRAM].alias || PROGRAM,
      headerTooltip: nameConventions[PROGRAM].alias || PROGRAM,
      tooltipField: 'name',
      field: 'name',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
      sort: 'asc',
      cellEditorPopup: true,
      cellStyle: { display: 'block' },
      context: PROGRAM,
      width: TABLE_COLUMN_WIDTH.DEFAULT,
    },
    {
      colId: 'addFromStarterKit3',
      headerName: 'Description',
      headerTooltip: 'Description',
      tooltipField: 'description',
      field: 'description',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      cellEditorParams: { maxLength: 100000 },
      cellStyle: { display: 'block' },
      context: 'Description',
      width: TABLE_COLUMN_WIDTH.DEFAULT,
    },
    {
      colId: 'addFromStarterKit4',
      headerName: nameConventions[USER_GROUP].alias || USER_GROUP,
      headerTooltip: nameConventions[USER_GROUP].alias || USER_GROUP,
      tooltipField: 'costCenter',
      field: 'costCenter',
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: getTableCostCenterOptions(activeCostCenters, costCenters),
      },
      editable: true,
      cellStyle: { display: 'block' },
      context: USER_GROUP,
      width: TABLE_COLUMN_WIDTH.DEFAULT,
    },
    { ...ErrorIconColumn() }
  ];
};

export const generateFromStarterKitResponseData = (response) => {
  const newPrograms = response[0].data;
  const serviceTypes = response[1].data;
  return { newPrograms, serviceTypes };
};

export const attachDefaultCostCenter = (
  programs,
  activeCostCenters,
  costCenters
) => {
  return programs.map((program) => {
    return {
      ...program,
      costCenter:
        activeCostCenters.length > 0 ? activeCostCenters[0] : costCenters[0],
    };
  });
};

export const ADD_PROGRAM_DIALOG_CASES = {
  NEW_PROGRAM: 'newProgram',
  SEARCH_POPUP: 'searchPopup',
  STARTER_KIT: 'starterKit',
};
export const ADD_PROGRAM_MENU_OPTIONS = [
  {
    label: 'Create new',
    value: 'newProgram',
  },
  {
    label: 'Create from search',
    value: 'programFromSearch',
  },
  {
    label: 'Create from starter kit',
    value: 'programFromStarterKit',
  },
];

export const attachServiceTypeName = (programs, serviceTypes) => {
  return programs.map((program) => {
    return {
      ...program,
      serviceTypeName: serviceTypes.find(
        (serviceType) => serviceType.id === program.serviceTypeId
      ).name,
    };
  });
};

export const getProgramInventoryHeaderButtons = (
  setAddProgramDialog,
  deselectGridRows,
  setOpenUploadDialog,
  dispatch,
  state,
  user,
  nameConventions
) => {
  return [
    {
      id: 'create',
      name: 'Create',
      variant: 'text',
      icon: 'plus',
      type: 'dropDown',
      popOverIcon: true,
      children: ADD_PROGRAM_MENU_OPTIONS,
      onClickFunction: (e) => {
        fireSelectedDialog(e, setAddProgramDialog, deselectGridRows);
      },
      disabled: user?.isViewOnly,
    },
    {
      id: 'export',
      name: 'Export',
      variant: 'text',
      icon: 'export',
      tooltip: messageManager(nameConventions).FILE_DOWNLOAD_IN_PROGRESS_MESSAGE,
      disabled: state.generatingDocument,
      onClickFunction: () => {
        dispatch({ type: REDUCER_ACTION_TYPES.GENERATING_DOCUMENT, payload: true });
        downloadProgramInventorySpreadsheet(user);
      },
    },
    {
      id: 'upload',
      name: 'Upload',
      variant: 'raised',
      before: true,
      onClickFunction: () => setOpenUploadDialog(true),
      disabled: user?.isViewOnly,
    },
  ];
};

export const getValidationPageNewUploadButton = (handleNewUpload) => {
  return [
    {
      id: 'upload',
      name: 'New upload',
      variant: 'text',
      icon: 'upload',
      onClickFunction: () => handleNewUpload(),
    },
  ];
};

export const INVENTORY_PREDICTOR_STEPS = [
  { label: 'Insights creation' },
  { label: 'Implementation plan' }
];

export const getSelectionToolBarButtons = (
  setShowCombinePopup,
  setShowRecommendationDialog,
  deselectGridRows,
  condition,
  user,
  handleClickDeleteMultiplePrograms,
  handleAnalyzePrograms,
  selectedRowsCount
) => {
  const Buttons = [
    {
      id: 'analyze',
      type: 'selection',
      name: 'Analyze processes',
      useAiButton: true,
      onClickFunction: () => handleAnalyzePrograms(),
      disabled: user?.isViewOnly,
      showCondition: selectedRowsCount > 1
    },
    {
      id: 'combine',
      type: 'selection',
      name: 'Combine',
      icon: 'vector_combine',
      ariaLabel: 'Combine selected programs',
      onClickFunction: () => setShowCombinePopup(true),
      disabled: user?.isViewOnly,
      showCondition: selectedRowsCount > 1
    },
    {
      id: 'delete',
      type: 'selection',
      name: 'Delete',
      icon: 'delete',
      onClickFunction: () => handleClickDeleteMultiplePrograms(),
      disabled: user?.isViewOnly,
      showCondition: selectedRowsCount > 1
    },
    {
      name: 'Recommend',
      onClickFunction: () => {
        setShowRecommendationDialog(true);
        deselectGridRows();
      },
      id: 'recommendations',
      disabled: user?.isViewOnly,
      useAiButton: true,
      type: 'buttonWithText',
      showCondition: selectedRowsCount > 1,
    },
  ];
  if (condition) {
    return Buttons.filter((button) => button.id !== 'recommendations');
  }
  return Buttons;
};

export const parseFile = async (
  fileObj,
  setColumns,
  setRows,
  setError,
  setLoading,
  retrieveColumnsFromStorage,
  setTotalCount,
  setOriginalRows,
  columnsOrderAndSize,
  nameConventions,
  user,
  setDisableSubmitButton
) => {
  setLoading(true);

  const arrayBuffer = await fileObj.arrayBuffer();

  const worker = new Worker(new URL('./excelWorker.js', import.meta.url), {
    type: 'module',
  });

  worker.onmessage = (e) => {
    const { data: csv_arr, error } = e.data;

    if (error) {
      setError(Array.isArray(error) ? error : [error]);
      setLoading(false);
      worker.terminate();
      return;
    }

    const { rows: normalizedRows, columns: excel_cols } = normalizeRowsToExpectedColumns(
      csv_arr,
      getDefaultExpectedColumns(nameConventions)
    );
    const colError = checkColumns(excel_cols, nameConventions);

    if (colError.length > 0) {
      setError(constructMissingColumnsMessage(colError));
      setDisableSubmitButton(true);
      setLoading(false);
      worker.terminate();
      return;
    }

    normalizedRows.forEach((row) => {
      row.Edit = trimValue(row.Edit);
    });

    const _columns = generateUploadColumnDefs(excel_cols, user, nameConventions);
    _columns.push(ErrorIconColumn());

    const columnsToSet = columnsOrderAndSize?.programInventoryProgramUploadValidationColumns?.length > 0
      ? retrieveColumnsFromStorage(_columns, 'programInventoryProgramUploadValidationColumns')
      : _columns;

    // 1. Set metadata and columns first
    setColumns(columnsToSet);
    setTotalCount(normalizedRows.length);

    // 2. Yield to allow React to mount the table structure
    requestAnimationFrame(() => {
      // 3. Set rows and original rows
      setRows(normalizedRows);

      // Defer expensive cloning to avoid main-thread freeze
      setTimeout(() => {
        setOriginalRows(structuredClone(normalizedRows));
      }, 50);

      // 4. ONLY turn off loading after the browser actually finishes painting the rows
      requestAnimationFrame(() => {
        setTimeout(() => {
          setLoading(false);
        }, 100);
      });
    });

    worker.terminate();
  };

  worker.onerror = () => {
    setError(['Failed to process file in background worker.']);
    setLoading(false);
    worker.terminate();
  };

  worker.postMessage({ arrayBuffer });
};

export const generateUploadColumnDefs = (columns, user, nameConventions) => {
  const costCenters = user.costCenters;

  return columns.map((col, ind) => {
    let cellEditor = 'agLargeTextCellEditor';
    let cellEditorParams = {};

    if (col === EDIT_TYPE_LABELS.EDIT) {
      cellEditor = 'agRichSelectCellEditor';
      cellEditorParams = {
        values: Object.values(EDIT_TYPE_LABELS),
      };
    } else if (col === nameConventions[USER_GROUP].alias) {
      cellEditor = 'agRichSelectCellEditor';
      cellEditorParams = {
        values: [...costCenters],
        allowTyping: true,
        highlightMatch: true,
      };
    }

    return {
      colId: `${ind}`,
      context: col,
      headerName: col,
      headerTooltip: col,
      tooltipField: col,
      field: col,
      valueSetter: (params) => {
        params.data[col] = typeof params.newValue === 'string' ? params.newValue.trim() : params.newValue;
        return true;
      },
      filter: false,
      suppressFloatingFilterButton: true,
      floatingFilter: false,
      sort: col === 'Edit' ? 'asc' : undefined,
      editable: col === 'Error' ? false : true,
      pinned: col === 'Error' ? 'right' : col === 'Edit' ? 'left' : false,
      lockPosition: col === 'Error' || col === 'Edit' ? 'left' : false,
      suppressColumnsToolPanel: true,
      cellEditorPopup: true,
      cellClass: 'grid-cell-centered',
      width: col === 'Error' ? 300 : col === 'Edit' ? 100 : undefined,
      cellEditor: cellEditor,
      cellEditorParams: cellEditorParams,
      cellStyle: { display: 'block' },
      resizable: col === 'Error' || col === 'Edit' ? false : true,
      suppressMovable: col === 'Error' || col === 'Action' ? true : false,
    };
  });
};

const getDefaultExpectedColumns = (nameConventions) => {
  return [
    'Edit',
    'ServiceType',
    nameConventions[PROGRAM_DEPARTMENT]?.alias,
    nameConventions[PROGRAM_DIVISION].alias,
    'Program number',
    nameConventions[PROGRAM].alias,
    'Description',
    'Comments',
    'ProgGroup',
    'ProgSubGroup',
    nameConventions[USER_GROUP].alias,
    'ProgID',
  ];
};

const checkColumns = (columns, nameConventions) => {
  let error = [];
  const normalizedColumns = columns.map((column) => normalizeColumnName(column));
  getDefaultExpectedColumns(nameConventions).forEach((col) => {
    if (!normalizedColumns.includes(normalizeColumnName(col))) {
      error.push(col);
    }
  });
  return error;
};

export const validateInput = (params, fileElementTracker, dbElementTracker, allowedProgramIds, user, nameConventions) => {
  const row = params.data;
  const editValue = trimValue(row['Edit']);
  const action = typeof editValue === 'string' ? editValue.toLowerCase() : editValue;
  const serviceType = row['ServiceType']?.toLowerCase();
  const program = row[nameConventions[PROGRAM].alias]?.toLowerCase();
  const progNumber = row['Program number']?.toString()?.toLowerCase();
  const department = row[nameConventions[PROGRAM_DEPARTMENT].alias]?.toLowerCase();
  const division = row[nameConventions[PROGRAM_DIVISION].alias]?.toLowerCase();
  const key = `${serviceType}---${progNumber}---${program}---${department}---${division}`;

  let errors = [];

  if (!action) {
    return errors;
  }

  errors = callValidators(row, {
    action,
    user,
    nameConventions,
    fileElementTracker,
    dbElementTracker,
    allowedProgramIds,
    key,
  });

  return errors;
};

const callValidators = (row, context) => {
  const validators = [
    validateAction,
    validateUserGroup,
    validateRequiredFields,
    validateServiceType,
    validateProgramId
  ];

  return validators.flatMap(fn => fn({ row, ...context }) || []);
};

const validateAction = ({ action }) => {
  const validActions = ['add', 'edit', 'delete'];
  if (!action || !validActions.includes(action)) {
    return [messageManager().VALID_ACTION_COLUMN_ERROR([EDIT_TYPE_LABELS.EDIT, EDIT_TYPE_LABELS.ADD, EDIT_TYPE_LABELS.DELETE])];
  }
  return [];
};

const validateUserGroup = ({ row, user, nameConventions }) => {
  const userGroup = row[nameConventions[USER_GROUP].alias];
  if (!userGroup.length) {
    return [`${nameConventions[USER_GROUP].alias} is required.`];
  }
  else if (
    !user.costCenters
      .map((cc) => cc.toLowerCase())
      .includes(userGroup.toLowerCase())
  ) {
    return [`User does not have access to this ${nameConventions[USER_GROUP].alias}.`];
  }
  return [];
};

const validateRequiredFields = ({ row, action, nameConventions }) => {
  const requiredFields = [
    {
      field: nameConventions[PROGRAM].alias,
      message: messageManager(nameConventions).PROGRAM_INVENTORY.UPLOAD_VALIDATOR_MISSING_PROGRAM,
    },
    { field: 'ServiceType', message: messageManager(nameConventions).PROGRAM_INVENTORY.UPLOAD_VALIDATOR_MISSING_SERVICE_TYPE, },
    { field: DESCRIPTION, message: messageManager(nameConventions).PROGRAM_INVENTORY.UPLOAD_VALIDATOR_MISSING_PROGRAM_DESCRIPTION, },
    {
      field: nameConventions[USER_GROUP].alias,
      message: messageManager(nameConventions).PROGRAM_INVENTORY.UPLOAD_VALIDATOR_MISSING_USER_GROUP
    },
  ];

  if (action !== 'delete') {
    for (const { field, message } of requiredFields) {
      if (!row[field] || /^\s+$/.test(row[field])) {
        return [message];
      }
    }
  }
  return [];
};

const validateServiceType = ({ row, action }) => {
  const serviceType = row['ServiceType'];

  if (action !== 'delete' && serviceType && !serviceTypes.includes(serviceType.toLowerCase())) {
    return ['Please specify a valid service type: Community, Governance, or Fixed'];
  }
  return [];
};

const validateProgramId = ({ row, action, fileElementTracker, dbElementTracker, allowedProgramIds, key, nameConventions }) => {
  const progId = row['ProgID'];
  if (action === 'edit' || action === 'delete') {
    if (!progId) {
      return ['Program ID is required.'];
    }

    if (!allowedProgramIds.includes(Number(progId))) {
      return [`${nameConventions[PROGRAM].alias} with such ID does not exist.`];
    }
  }

  if (action === 'delete') {
    if (
      !Object.values(dbElementTracker)
        .map((x) => x.id)
        .includes(Number(row['ProgID']))
    ) {
      return ['Program ID does not exist.'];
    }
  }

  if (fileElementTracker[key] > 1) {
    return ['Duplicate program data.'];
  }

  if (dbElementTracker[key]?.count > 1 && action === 'add') {
    return [`${nameConventions[PROGRAM].alias} already exists in the database.`];
  }

  return [];
};

export const generateProgramForUpload = (row, nameConventions) => {
  return {
    ProgID: row['ProgID'],
    ServiceType: row['ServiceType'],
    Department: row[nameConventions[PROGRAM_DEPARTMENT].alias] === null ? '' : row[nameConventions[PROGRAM_DEPARTMENT].alias],
    Division: row[nameConventions[PROGRAM_DIVISION].alias] === null ? '' : row[nameConventions[PROGRAM_DIVISION].alias],
    ProgramNum: row['Program number']?.toString(),
    Program: row[nameConventions[PROGRAM].alias],
    Description: row['Description'] ? row['Description'].toString() : '',
    Comments: row['Comments'],
    ProgGroup: row['ProgGroup'],
    ProgSubGroup: row['ProgSubGroup'],
    CostCenters: row[nameConventions[USER_GROUP].alias],
    Edit: trimValue(row['Edit']),
  };
};

export const generateElementTrackers = (
  rows,
  dbElementTracker,
  nameConventions
) => {
  const fileElementTracker = {};
  const _dbElementTracker = JSON.parse(JSON.stringify(dbElementTracker));

  rows.forEach((data) => {
    const editValue = trimValue(data['Edit']);
    const action =
      typeof editValue === 'string'
        ? editValue.toLowerCase()
        : editValue;

    const serviceType = data['ServiceType']?.toLowerCase();
    const program = data[nameConventions[PROGRAM].alias]?.toLowerCase();
    const progNumber = data['Program number']?.toString()?.toLowerCase();
    const department = data[nameConventions[PROGRAM_DEPARTMENT].alias]?.toLowerCase();
    const division = data[nameConventions[PROGRAM_DIVISION].alias]?.toLowerCase();
    const key = `${serviceType}---${progNumber}---${program}---${department}---${division}`;

    if (action !== 'delete') {
      fileElementTracker[key] = (fileElementTracker[key] || 0) + 1;
    }

    if (
      (action === 'add' || action === 'edit') &&
      _dbElementTracker[key]
    ) {
      _dbElementTracker[key].count += 1;
    }
  });

  return { fileElementTracker, _dbElementTracker };
};

export const getGenerateProgramsDialogFields = (nameConventions) => [
  {
    id: 'orgURL',
    name: 'Organization URL',
    icon: 'content_paste',
    type: 'textfield',
  },
  {
    id: 'numberOfPrograms',
    name: `Number of programs per ${nameConventions[PROGRAM_DEPARTMENT].alias?.toLowerCase()}`,
    type: 'number',
  },
];

export const getRecommendationColumnDefs = (
  serviceTypes,
  activeCostCenters,
  user,
  nameConventions,
  departmentsAndDivisions
) => {
  return [
    {
      colId: 'serviceType',
      context: 'Service Type',
      headerName: 'Service Type',
      headerTooltip: 'Service Type',
      tooltipField: 'service_type',
      field: 'service_type',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: serviceTypes.map((serviceType) => serviceType.name),
        allowTyping: true,
        highlightMatch: true,
      },
      editable: true,
    },
    {
      colId: 'department',
      context: PROGRAM_DEPARTMENT,
      headerName: nameConventions[PROGRAM_DEPARTMENT].alias || PROGRAM_DEPARTMENT,
      headerTooltip: nameConventions[PROGRAM_DEPARTMENT].alias || PROGRAM_DEPARTMENT,
      tooltipField: 'department',
      field: 'department',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: getOrgLevelEditorValues(departmentsAndDivisions?.departments),
        allowTyping: true,
        highlightMatch: true,
      },
      editable: true,
      cellStyle: { display: 'block' },
      width: TABLE_COLUMN_WIDTH.XL,
    },
    {
      colId: 'division',
      context: PROGRAM_DIVISION,
      headerName: nameConventions[PROGRAM_DIVISION].alias || PROGRAM_DIVISION,
      headerTooltip: nameConventions[PROGRAM_DIVISION].alias || PROGRAM_DIVISION,
      tooltipField: 'division',
      field: 'division',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: getOrgLevelEditorValues(departmentsAndDivisions?.divisions),
        allowTyping: true,
        highlightMatch: true,
      },
      editable: true,
      cellStyle: { display: 'block' },
      width: TABLE_COLUMN_WIDTH.XL,
    },
    {
      colId: 'programName',
      context: PROGRAM,
      headerName: nameConventions[PROGRAM].alias || PROGRAM,
      headerTooltip: nameConventions[PROGRAM].alias || PROGRAM,
      tooltipField: 'program_name',
      field: 'program_name',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      // cellClass: (params) => {
      //   return params.data.program_name &&
      //     params.data.program_name.trim().length !== 0
      //     ? 'normalCell'
      //     : 'emptyRequiredCell';
      // },
      cellStyle: { display: 'block' },
    },
    {
      colId: 'programDescription',
      context: 'Description',
      headerName: 'Description',
      headerTooltip: 'Description',
      tooltipField: 'program_description',
      field: 'program_description',
      cellEditorPopup: true,
      // cellClass: (params) => {
      //   return params.data.program_description &&
      //     params.data.program_description.trim().length !== 0
      //     ? 'normalCell'
      //     : 'emptyRequiredCell';
      // },
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: { maxLength: 100000 },
      cellStyle: { display: 'block' },
    },
    {
      colId: 'costCenter',
      context: USER_GROUP,
      headerName: nameConventions[USER_GROUP].alias || USER_GROUP,
      headerTooltip: nameConventions[USER_GROUP].alias || USER_GROUP,
      tooltipField: 'costCenter',
      field: 'costCenter',
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: getTableCostCenterOptions(activeCostCenters, user.costCenters),
        allowTyping: true,
        highlightMatch: true,
      },
      editable: true,
      cellStyle: { display: 'block' },
    },
    {
      colId: 'confidenceScore',
      headerName: 'Confidence score',
      headerTooltip: 'Confidence score',
      tooltipField: 'confidence_score',
      field: 'confidence_score',
      editable: false,
    },
    {
      colId: 'reason',
      headerName: 'Reason',
      field: 'reason',
      tooltipField: 'reason',
      headerTooltip: 'Reason',
      editable: false,
    },
    { ...ErrorIconColumn() }
  ];
};

export const getDisablingCondition = (selectedRows) => {
  return (
    selectedRows.length === 0 ||
    selectedRows.filter(
      (entity) =>
        !entity.description ||
        !entity.name ||
        entity.description.trim() === '' ||
        entity.name.trim() === ''
    ).length > 0
  );
};

export const getDisablingConditionForRecommendationServicePrograms = (selectedRows) => {
  return (
    selectedRows.length === 0 ||
    selectedRows.filter(
      (entity) =>
        !entity.program_description ||
        !entity.program_name ||
        entity.program_description.trim() === '' ||
        entity.program_name.trim() === ''
    ).length > 0
  );
};

export const validateRowsFromAddProgram = (gridRef, nameConventions) => {
  gridRef.current.api.forEachNode(row => {
    if (!row.data.serviceTypeName) {
      row.data['Error'] = 'Service type is required';
    } else if (!row.data.costCenter) {
      row.data['Error'] = `${nameConventions[USER_GROUP].alias || USER_GROUP} is required`;
    } else if (!row.data.description?.trim()) {
      row.data['Error'] = 'Description is required';
    } else if (!row.data.name?.trim()) {
      row.data['Error'] = `${nameConventions[PROGRAM].alias || PROGRAM} is required`;
    } else {
      row.data['Error'] = null;
    }

    if (row.data['Error']) {
      if (row.isSelected()) {
        row.setSelected(false);
        row.selectable = false;
      } else {
        row.selectable = true;
      }
    }
  });
};

export const validateRowsFromRecommendProgram = (gridRef, nameConventions) => {

  gridRef.current.api.forEachNode(row => {
    if (!row.data.service_type) {
      row.data['Error'] = 'Service type is required';
    } else if (!row.data.costCenter) {
      row.data['Error'] = `${nameConventions[USER_GROUP].alias || USER_GROUP} is required`;
    } else if (!row.data.program_description?.trim()) {
      row.data['Error'] = 'Description is required';
    } else if (!row.data.program_name?.trim()) {
      row.data['Error'] = `${nameConventions[PROGRAM].alias || PROGRAM} is required`;
    } else {
      row.data['Error'] = null;
    }

    if (row.data['Error']) {
      if (row.isSelected()) {
        row.setSelected(false);
        row.selectable = false;
      } else {
        row.selectable = true;
      }
    }
  });
};

export const prepProgramsForAnalyzing = (selectedRows) => {
  return selectedRows.map(prog => {
    return {
      id: prog.id,
      name: prog.name,
      description: prog.description,
      department: prog.department,
    };
  });
};

export const OVERLAP_STEPS = [
  { label: 'Key processes' },
  { label: 'Visualization' },
  { label: 'Overlap analysis' },
];

export const getSplitButtonOptions = (analysisResponse, overlapAnalysis, introAndConclusion, user) => [
  {
    label: 'As Excel',
    value: 'excel',
    icon: 'file_excel',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true },
    onClick: () => downloadProgramProcessOverlapExcel(analysisResponse, user)
  },
  {
    label: 'As PDF',
    value: 'pdf',
    icon: 'file_pdf',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true },
    onClick: () => downloadProgramProcessOverlapPDF(overlapAnalysis, analysisResponse, introAndConclusion, user)
  }
];

export const prepDepartmentsAndDivisions = (filteredData) => {
  return {
    departments: [
      '',
      ...filteredData.data
        .filter((x) => x.orgLevelNumber === 1)
        .map((x) => x.orgLevelName)
        .sort((a, b) => a.localeCompare(b)),
    ],
    divisions: [
      '',
      ...filteredData.data
        .filter((x) => x.orgLevelNumber === 2)
        .map((x) => x.orgLevelName)
        .sort((a, b) => a.localeCompare(b)),
    ],
  };
};

export const groupByProcessType = (programs) => {
  const result = programs
    .flatMap(program => program.processes) // flatten all processes
    .reduce((acc, process) => {
      const key = process.process_type;

      if (!acc[key]) {
        acc[key] = { process_type: key, count: 0 };
      }

      acc[key].count += 1;

      return acc;
    }, {});

  return Object.values(result).sort((a, b) => b.count - a.count);
};

export const structureOverlapAnalysis = (data) => {
  const overlapAnalysisArray = TITLE_PATH_OVERLAP_RELATION.map(entity => {
    return {
      tempId: Math.random().toString(36).substring(2),
      name: entity.title,
      entities: extractOverlapInfo(data[entity.path]),
    };
  });

  return overlapAnalysisArray;
};

const TITLE_PATH_OVERLAP_RELATION = [
  {
    path: 'common_process_types',
    title: '1. Common process types'
  },
  {
    path: 'specific_process_overlaps',
    title: '2. Specific process overlaps'
  },
  {
    path: 'cross_department_consolidation_opportunities',
    title: '3. Consolidation opportunities'
  },
  {
    path: 'shared_service_recommendations',
    title: '4. Shared service recommendations'
  },
  {
    path: 'implementation_priority',
    title: '5. Implementation priority'
  },
  {
    path: 'expected_benefits',
    title: '6. Expected benefits'
  }
];

const extractOverlapInfo = (data) => {
  return Object.entries(data).map(
    ([key, value]) => ({
      tempId: Math.random().toString(36).substring(2),
      process: key,
      values: value.map(val => {
        return {
          value: val,
          tempId: Math.random().toString(36).substring(2)
        };
      }),
    })
  );
};

export const wrapLabels = (labels) =>
  labels.map(label =>
    label.length >= 20
      ? `${label.substring(0, 10)}...`
      : label
  );

export const getKeyProcesses = (data) => {
  return data.map(
    (process) => {
      return {
        ...process,
        tempId: Math.random().toString(36).substr(2, 9),
        processes: process.processes.map((proc) => {
          return {
            ...proc,
            tempId: Math.random().toString(36).substr(2, 9),
          };
        }),
      };
    },
  );
};

export const validateProgramsForAnalyzing = (programs) => {
  return programs.some(
    ({ name, description }) =>
      !name?.trim() || !description?.trim()
  );
};

export const convertSelectedCardsFromArrayToObject = (selectedCards) => {
  const departments = {};
  selectedCards
    .map(x => x.split('(')[0])
    .forEach(x => {
      departments[x] = '';
    });
  return departments;
};

